export enum FranchiseType {
  Percentage = 'percentage',
  Amount = 'amount'
}
